import { cerrarSesion } from "../utilities/Seguridad";
import axios from "axios";
import qs from "qs";
const FormData = require("form-data");
const request = require("request");

const sendAxios = async (config) => {
    let res = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });
    return res;
};

export async function listaCurso(idColegio, anio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/grados/${anio}/listar`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function listaNivel(token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/configuracion/nivel`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function listaSeccion(token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/configuracion/seccion`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function listaProfesores(idColegio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/profesores`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

// curso = Grado
export async function crearGradoCurso(idColegio, anio, grado, token) {
    let data = qs.stringify({
        idNivel: grado.nivel.id,
        idSeccion: grado.letra.id,
        nombre: grado.nombre,
        idProfesional: grado.profesional.id,
        capacidad: grado.capacidad,
    });

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/grados/${anio}/crear`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

export async function editarGradoCurso(idColegio, anio, grado, token) {
    let data = qs.stringify({
        idNivel: grado.nivel.id,
        idSeccion: grado.letra.id,
        nombre: grado.nombre,
        idProfesional: grado.profesional.id,
        capacidad: grado.capacidad,
    });

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/grados/${anio}/editar/${grado.id}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

export async function eliminarGradoCurso(idColegio, idGrado, token) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/grados/eliminar/${idGrado}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

// Asignaturas
export async function getListaAsignaturas(idColegio, idNivel, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/asignaturas/${idColegio}/${idNivel}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function editarAsignatura(idColegio, asignatura, token) {
    let data = new FormData();
    data.append("idasignatura", asignatura.id);
    data.append("alias", asignatura.alias);
    data.append("idsprofesional", asignatura.profesionales_json); // '[{"id":3},{"id":8}]'

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/asignaturas/${idColegio}/editar`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

// Talleres
export async function getListaTalleres(idColegio, anio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/talleres/${idColegio}/${anio}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await sendAxios(config);
    return response;
}

// Crear Taller
export async function crearTaller(idColegio, idNivell, tallerNombre, token) {
    let data = null;
    if (idNivell == 0) {
        data = qs.stringify({
            nombre: tallerNombre,
        });
    } else {
        data = qs.stringify({
            idNivel: idNivell,
            nombre: tallerNombre,
        });
    }

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/talleres/${idColegio}/crear`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

export async function eliminarTaller(idColegio, idTaller, token) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/talleres/${idColegio}/eliminar/${idTaller}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await sendAxios(config);
    return response;
}

// Editar Taller
export async function editarTaller(idColegio, taller, token) {
    let data = qs.stringify({
        idsprofesional: taller.profesionales_json,
        alias: taller.alias,
        idsmatricula: taller.matriculas_json,
    });

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/talleres/${idColegio}/editar/${taller.id}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

/////// Bloque

export async function listaBloque(idColegio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/bloque/${idColegio}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function registrarBloque(idColegio, bloque, token) {
    let data = null;
    if (bloque.id == null) {
        data = qs.stringify({
            tipo: bloque.tipo.id,
            nombre: bloque.nombre,
            duracion: bloque.duracion,
        });
    } else {
        data = qs.stringify({
            tipo: bloque.tipo.id,
            nombre: bloque.nombre,
            idbloque: bloque.id,
            duracion: bloque.duracion,
        });
    }
    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/bloque/${idColegio}/registro`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

export async function eliminarBloque(idColegio, idBloque, token) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/bloque/${idColegio}/eliminar/${idBloque}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await sendAxios(config);
    return response;
}

// HORARIOS

export async function listaDiasConfig(idColegio, idGrado, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/horario/${idColegio}/${idGrado}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function registrarHorario(idColegio, idGrado, es_update, tipo, horario, token) {

    let data = null;
    let horarioData = {};

    if (es_update) horarioData.idHorario = horario.idHorario;

    horarioData.idDiaSem = horario.idDiaSem;
    horarioData.idBloque = horario.idBloque;
    horarioData.inicio = horario.inicio;
    horarioData.fin = horario.fin;

    if (tipo == 2) {
        horarioData.idAsigCole = horario.idAsigCole;
        horarioData.idProfesional = horario.idProfesional;
    }

    if (tipo == 3) {
        horarioData.idTaller = horario.idTaller;
        horarioData.idProfesional = horario.idProfesional;
    }

    data = qs.stringify(horarioData);

    console.log(horarioData);

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/horario/${idColegio}/${idGrado}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}

export async function eliminarBloqueHorario(idColegio, idHorario, token) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/horario/${idColegio}/eliminar/${idHorario}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await sendAxios(config);
    return response;
}

export async function listaProfesoresHorario(es_asignatura, idAsignaturaOTaller, idColegio, token) {
    let urlNUevo = es_asignatura ? `colegio/${idColegio}/profesores/${idAsignaturaOTaller}` : `talleres/${idColegio}/profesores/${idAsignaturaOTaller}`;

    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/${urlNUevo}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function getListaAsignaturasHorarioCurso(idColegio, idGrado, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/asignaturas/${idColegio}/grado/${idGrado}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await sendAxios(config);
    return response;
}

export async function setHorarioConfigInicio(inicio, idDiaSem, idGrado, token) {
    let data = qs.stringify({
        inicio: inicio,
        idDiaSem: idDiaSem,
    });

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/horario/configurar-inicio/${idGrado}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await sendAxios(config);
    return response;
}


export async function viewPDF(content, nameFile) {

    let dataHtml = qs.stringify({
        'content': content 
      });

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL_FRONT}/pdf`,
        responseType: "blob",
        maxBodyLength: Infinity,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: dataHtml
    };

    const response = await axios(config)
        .then((response) => {
            let url = URL.createObjectURL(new Blob([response.data]), { type: 'application/pdf' });
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nameFile);
            document.body.appendChild(link);
            link.click();
            return true;
        })
        .catch((error) => {
            console.log(error);
            return false;
        });
    return response;
}

export async function downloadPdfHorarioCurso(idColegio, idGrado, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/horario/descarga/${idColegio}/${idGrado}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await sendAxios(config);
    return response;
}

export async function downloadPdfHorarioProfesor(idColegio, idProfesor, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/horario-profesor/descarga/${idColegio}/${idProfesor}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await sendAxios(config);
    return response;
}
